import './style.css'
const NavLine =()=>{
    return(
        <>
        <div className='nav-line'></div>
        </>
    )
}
export default NavLine